import React from 'react';
import PropTypes from 'prop-types';
import uuidv1 from 'uuid/v1';
import HomePageDisplay from './HomePageDisplay';

class HomePageContainer extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    account: PropTypes.object
  }

  static defaultProps = {
    account: {}
  }

  state = {
    licensePanelOpen: false,
    licenseTableRefreshKey: uuidv1(),
    licensePanelRefreshKey: uuidv1(),
    editId: undefined,
    label: undefined
  }

  openPanel = (label, id = undefined) => {
    this.refreshPanelKey();
    this.setState({ licensePanelOpen: true, label, editId: id });
  }

  closePanel = () => {
    this.setState({ licensePanelOpen: false, editId: undefined });
  }

  refreshLicenseTableKey = () => {
    this.setState({ licenseTableRefreshKey: uuidv1() });
  }

  refreshPanelKey = () => {
    this.setState({ licensePanelRefreshKey: uuidv1() });
  }

  openPanelForEdit = (id) => {
    this.openPanel('Edit License', id);
  }

  render() {
    const { account } = this.props;
    const isProducer = account.carrierAccount != null ? account.carrierAccount.IsProducer : undefined;
    return (
      <HomePageDisplay
        history={ this.props.history }
        licensePanelOpen={ this.state.licensePanelOpen }
        openPanel={ this.openPanel }
        closePanel={ this.closePanel }
        refreshLicenseTableKey={ this.refreshLicenseTableKey }
        licenseTableRefreshKey={ this.state.licenseTableRefreshKey }
        licensePanelRefreshKey={ this.state.licensePanelRefreshKey }
        refreshPanelKey={ this.refreshPanelKey }
        panelLabel={ this.state.label }
        editId={ this.state.editId }
        onEdit={ this.openPanelForEdit }
        isProducer={ isProducer }
      />
    );
  }
}

export default HomePageContainer;
